import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser'
import { MdIconRegistry } from '@angular/material'

@Component({
  selector: 'cm-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarComponent implements OnInit {

  constructor(iconRegistry: MdIconRegistry, domSanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      'film',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/img/icon/ic_film.svg')
    )
    iconRegistry.addSvgIcon(
      'discussion',
      domSanitizer.bypassSecurityTrustResourceUrl('assets/img/icon/ic_discussion.svg')
    )
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/toolbar/toolbar.component.ts